// extracted by mini-css-extract-plugin
export default {"Carousel":"Carousel_Carousel__eGKs0","Carousel__content":"Carousel_Carousel__content__BEFMH","Carousel__button":"Carousel_Carousel__button__0oN-y"};